<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M9.02057 21.2823C9.05203 21.3006 9.07676 21.3146 9.09427 21.3245L9.12336 21.3407C9.35552 21.4682 9.6435 21.4672 9.87588 21.3411L9.90573 21.3245C9.92324 21.3146 9.94797 21.3006 9.97943 21.2823C10.0424 21.2459 10.1323 21.1927 10.2453 21.1231C10.4713 20.9839 10.7904 20.7787 11.1715 20.5095C11.9324 19.972 12.9477 19.1744 13.9652 18.1326C15.9903 16.0592 18.0938 12.9439 18.0938 8.9375C18.0938 4.1913 14.2462 0.34375 9.5 0.34375C4.7538 0.34375 0.90625 4.1913 0.90625 8.9375C0.90625 12.9439 3.00971 16.0592 5.03485 18.1326C6.05235 19.1744 7.06762 19.972 7.82853 20.5095C8.20963 20.7787 8.52868 20.9839 8.75469 21.1231C8.86774 21.1927 8.95765 21.2459 9.02057 21.2823ZM9.5 12.0625C11.2259 12.0625 12.625 10.6634 12.625 8.9375C12.625 7.21161 11.2259 5.8125 9.5 5.8125C7.77411 5.8125 6.375 7.21161 6.375 8.9375C6.375 10.6634 7.77411 12.0625 9.5 12.0625Z"
				:fill="color" 
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgPin',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>